/* Sura – testimonials
   Keeps the "Helpful" button honest: it toggles a pressed state and remembers
   the visitor's choice locally. No counts are faked and nothing is sent
   anywhere, since these reviews are editor-managed content. */
(function () {
  'use strict';

  var STORAGE_KEY = 'sura:testi-helpful';

  function readStore() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function writeStore(store) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
    } catch (e) {
      /* private mode / storage full – the toggle still works for this session */
    }
  }

  function init() {
    var buttons = document.querySelectorAll('[data-testi-helpful]');
    if (!buttons.length) return;

    var store = readStore();

    buttons.forEach(function (button) {
      var key = button.dataset.testiKey;

      if (key && store[key]) {
        button.setAttribute('aria-pressed', 'true');
      }

      button.addEventListener('click', function () {
        var pressed = button.getAttribute('aria-pressed') === 'true';
        button.setAttribute('aria-pressed', pressed ? 'false' : 'true');

        if (!key) return;
        store = readStore();
        if (pressed) {
          delete store[key];
        } else {
          store[key] = 1;
        }
        writeStore(store);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
